var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_800)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6902 3.35557C31.2952 3.75058 30.6601 3.76607 30.2496 3.39817L19.6113 14.0403L15.9129 17.7387C15.9129 17.7387 15.9245 21.2706 15.0222 22.1768L5.44113 31.7578C4.53493 32.6641 3.06331 32.6641 2.1571 31.7578L0.685476 30.2862C-0.182006 29.4187 -0.220732 28.0439 0.565423 27.13C0.60415 27.0874 0.642877 27.0448 0.685476 27.0022L10.2665 17.4212C11.1727 16.515 14.7433 16.4917 14.7433 16.4917L17.1986 14.0364L18.4069 12.8282L29.0452 2.18602C29.0452 2.18602 29.0452 2.18602 29.0335 2.17053C28.6811 1.76002 28.7005 1.13652 29.0878 0.745378C29.4983 0.334874 30.1644 0.334874 30.5787 0.745378L31.6941 1.86071C32.1046 2.27122 32.1046 2.93732 31.6941 3.3517L31.6902 3.35557Z",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0183 22.1765L5.43731 31.7614C4.53111 32.6677 3.05948 32.6677 2.15328 31.7614L0.681656 30.2898C-0.181953 29.4262 -0.224552 28.0475 0.561603 27.1336C0.604203 27.2498 0.611948 27.3892 0.685529 27.5015C4.42267 33.1982 13.6397 21.3594 13.9959 20.8327C15.0687 19.2527 15.2313 17.2079 15.2313 17.2079L29.7617 2.67757C31.3223 3.10357 31.1326 1.30664 31.1326 1.30664L31.6903 1.86431C32.1008 2.27481 32.1008 2.94091 31.6903 3.35529C31.2952 3.75031 30.664 3.7658 30.2496 3.39789L15.9091 17.7384C15.9091 17.7384 15.9245 21.2703 15.0183 22.1765Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD11);
export default __webpack_public_path__ + "static/media/d11.8764cc02145cd46ee9f970eb3b6b8da1.svg";
export { ForwardRef as ReactComponent };